<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbUser } from '@/models/alodb/AloDbUser'
import AdminUserRights from '@/components/admin/user/AdminUserRights.vue'
import AdminForm from '@/components/admin/AdminForm.vue'


@Component({
  name: 'AdminUserRightsTab', 
  components:{AdminUserRights}
})
export default class AdminUser extends AdminForm<AloDbUser> {    
  get itemTypeName(){
    return "User"
  }

  get componentName(){
    return "AdminUserRights"
  }

  get showActionArea() {
    return false
  }

  get showTitle(){
    return false
  }
  
}
</script>